import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { LogoUrl } from 'src/app/core/constants/constants';
import { InstitutionDto, TestPurposeDto } from 'src/app/core/dtos/dto';
import { BrandEnum, TestPurposeEnum, TestTypeEnum } from 'src/app/core/dtos/enum';
import { TestPurposeOption } from 'src/app/core/dtos/test-purpose-option';
import { ConfigHelper } from 'src/app/core/services/helpers/config.helper';
import { RegistrationService } from 'src/app/core/services/registration.service';
import { selectIsBusinessAccount } from 'src/app/state/my-account.selectors';
import { setTestPurposeOption, setTestTypeId } from 'src/app/state/reg-data.actions';
import { selectInstitutionLookup, selectTestPurposeLookup, selectTestPurposeOption, selectCollegeLookup } from 'src/app/state/reg-data.selectors';

@Component({
  selector: 'app-test-selection',
  templateUrl: './test-selection.component.html',
  styleUrls: ['./test-selection.component.scss']
})
export class TestSelectionComponent implements OnInit, OnDestroy {

  isBusinessAccount: boolean;
  isWebDelivery: boolean;
  celpipGLogo: string;
  celpipLSLogo: string;
  selectedTestTypeId: number;
  testTypeId: number;
  pageTitle: string;
  brandId: BrandEnum;
  businessAccountSubscription: Subscription;
  testPurposes$: Observable<TestPurposeDto[]>;
  institutions$: Observable<InstitutionDto[]>;
  subscribedInstitutions$: Observable<Map<TestPurposeEnum, InstitutionDto[]>>;
  selectedTestPurposeOption$: Observable<TestPurposeOption>;
  testTypeGId = TestTypeEnum.CELPIP_G;
  testTypeLSId = TestTypeEnum.CELPIP_LS;

  constructor(
    private store: Store,
    private configHelper: ConfigHelper,
    private registrationService: RegistrationService,
    private router: Router,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    this.brandId = this.configHelper.getBrandId();
    if (this.brandId !== BrandEnum.CELPIP) {
      this.router.navigate(['my-account']);
    }
    // when using the links from WordPress
    this.route.queryParams
      .subscribe(params => {
        if (params.siteCode && params.testTypeId) {
          this.router.navigate(['/registration/proof-of-identity'], { queryParams: { siteCode: params.siteCode, testTypeId: params.testTypeId } });
        }
        else {
          this.celpipGLogo = this.configHelper.getImageUrl(LogoUrl.LOGO_URL_MAP.get("CELPIP_GENERAL_LOGO"));
          this.celpipLSLogo = this.configHelper.getImageUrl(LogoUrl.LOGO_URL_MAP.get("CELPIP_LS_LOGO"));
          this.testPurposes$ = this.store.pipe(select(selectTestPurposeLookup));
          this.institutions$ = this.store.pipe(select(selectInstitutionLookup));
          this.subscribedInstitutions$ = this.store.pipe(select(selectCollegeLookup));
          this.selectedTestPurposeOption$ = this.store.pipe(select(selectTestPurposeOption));
          this.isWebDelivery = this.router.url.includes('web-delivery');
          this.pageTitle = this.isWebDelivery ? 'Which online test are you taking?' : 'Which test are you taking?';
          this.checkBusinessAccount();
        }
      });

  }

  public get BrandEnum() {
    return BrandEnum;
  }

  checkBusinessAccount() {
    this.businessAccountSubscription = this.store.select(selectIsBusinessAccount).pipe(take(1))
      .subscribe(
        (result) => {
          this.isBusinessAccount = result;
        }
      );
  }

  selectTest(testTypeId: number) {
    this.testTypeId = testTypeId;
  }

  confirmSelectTest() {
    this.selectedTestTypeId = this.testTypeId;
    this.setTestPurposeLookUp(this.selectedTestTypeId);
  }

  setTestPurposeLookUp(testTypeId: number) {
    this.registrationService.setTestPurposeLookUp(testTypeId, this.isWebDelivery);
  }

  onContinue(testPurposeOption: TestPurposeOption) {
    this.store.dispatch(setTestPurposeOption({ testPurposeOption }));
    this.store.dispatch(setTestTypeId({ testTypeId: this.selectedTestTypeId }));
    if (this.isBusinessAccount) {
      this.router.navigate(['batch-registration/sitting-selection']);
    }
    else {
      if (this.isWebDelivery) {
        this.router.navigate(['registration/sitting-selection-web-delivery']);
      }
      else {
        this.router.navigate(['registration/sitting-selection']);
      }
    }
  }

  ngOnDestroy(): void {
    this.businessAccountSubscription?.unsubscribe();
  }


}
